import { render, staticRenderFns } from "./configModal.vue?vue&type=template&id=8a78c7ac&scoped=true"
import script from "./configModal.vue?vue&type=script&lang=js"
export * from "./configModal.vue?vue&type=script&lang=js"
import style0 from "./configModal.vue?vue&type=style&index=0&id=8a78c7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a78c7ac",
  null
  
)

export default component.exports